/**
 * What the workspace calls each task job.
 *
 * "Task job #N" is an ordinal over the jobs an operator can see, not a
 * database id and not a position in the list the API answers with: that list
 * also carries the hidden SSN job, which has a tab of its own. Counting it
 * pushed every label after it up by one, and the list arrives newest first, so
 * a major job with an SSN job had every number wrong (CAL-6161).
 */

/** The SSN job the SSN tab owns; the Task jobs list never shows it. */
export function isHiddenJob(job: Record<string, unknown>): boolean {
  return String(job.bot_name ?? "").startsWith("ssn_bots.");
}

/** The jobs the Task jobs list shows, in the order it shows them. */
export function visibleJobs(
  jobs: Array<Record<string, unknown>>,
): Array<Record<string, unknown>> {
  return jobs.filter((job) => !isHiddenJob(job));
}

/**
 * The number the panel calls this job, counting the visible ones from 1.
 *
 * null when the job is not among them - a job just deleted, or the hidden SSN
 * job, which is never labelled this way.
 */
export function jobOrdinal(
  jobs: Array<Record<string, unknown>>,
  jobId: number | null | undefined,
): number | null {
  if (jobId == null) return null;
  const index = visibleJobs(jobs).findIndex(
    (job) => Number(job.id) === Number(jobId),
  );
  return index >= 0 ? index + 1 : null;
}
